import React, { useEffect, useRef, useState } from 'react';
import './CommonDialog.scss';
import HtmlContent from './HtmlContent';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';


const CommonDialog = ({
    show,
    onHide,
    dialogId = 'appCommonDialog',
    dialogClass,
    headerClass,
    title,
    titleClass,
    body,
    bodyClass,
    size,
    centered = true,
    scrollable = true,
    noCloseBtn = true,
    onConfirm,
    onCancel,
    confirmBtnText = 'OK',
    confirmBtnColor = 'primary',
    confirmBtnClass,
    cancelBtnText = 'Cancel',
    cancelBtnColor = 'outline-secondary',
    cancelBtnClass,
    footerClass = 'confirmDialogFooter',
    backdrop = 'static',
    keyboard = false,
}) => {

    const modalRef = useRef(null);

  useEffect(() => {
    if (show && modalRef.current.dialog) {
        modalRef.current.dialog.setAttribute('id', 'commonDialog');
    }
  }, [show]);

    return (
            <Modal show={show} onHide={onHide} size={size} centered={centered}
            id={dialogId} backdrop={backdrop} keyboard={keyboard} dialogClassName={dialogClass}
            scrollable={scrollable} ref={modalRef}>
                
            {(!noCloseBtn || title) && (
                <Modal.Header closeButton={!noCloseBtn} className={headerClass}>
                    <Modal.Title className={titleClass}><HtmlContent content={title} /></Modal.Title>
                </Modal.Header>
            )}

            {body && (
                <Modal.Body className={bodyClass}>
                    <HtmlContent content={body} />
                </Modal.Body>
            )}

            {(onCancel || onConfirm) &&
                <Modal.Footer className={footerClass}>
                    {onCancel && (
                        <Button className={cancelBtnClass} variant={cancelBtnColor} onClick={onCancel}>
                            {cancelBtnText}
                        </Button>
                    )}

                    {onConfirm && (
                        <Button autoFocus className={confirmBtnClass} variant={confirmBtnColor} onClick={onConfirm}>
                            {confirmBtnText}
                        </Button>
                    )}
                </Modal.Footer>
            }
        </Modal>
    );
};

// Prop validation
CommonDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    dialogId: PropTypes.string,
    dialogClass: PropTypes.string,
    headerClass: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    titleClass: PropTypes.string,
    body: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    bodyClass: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg', 'xl', 'fullscreen', 'fullscreen-sm-down', 'fullscreen-md-down', 'fullscreen-lg-down', 'fullscreen-xl-down', 'fullscreen-xxl-down']),
    centered: PropTypes.bool,
    scrollable: PropTypes.bool,
    noCloseBtn: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    confirmBtnText: PropTypes.string,
    confirmBtnColor: PropTypes.string,
    confirmBtnClass: PropTypes.string,
    cancelBtnText: PropTypes.string,
    cancelBtnColor: PropTypes.string,
    cancelBtnClass: PropTypes.string,
    footerClass: PropTypes.string,
    backdrop: PropTypes.string,
    keyboard: PropTypes.bool
};


export default CommonDialog;